import { Component, OnInit } from '@angular/core';
import { AbstractDetailsComponent } from '../../../../shared/abstracts/details/abstract-details/abstract-details.component';
import { IMedicationRequest, ICodeableConcept } from '@ahryman40k/ts-fhir-types/lib/R4';
import { DAYS, DOSAGE_PERIODS } from '../../constants/medication-constants';

@Component({
  selector: 'inc-taked-medication-details',
  templateUrl: './taked-medication-details.component.html',
  styleUrls: ['./taked-medication-details.component.scss'],
})
export class TakedMedicationDetailsComponent extends AbstractDetailsComponent<IMedicationRequest> implements OnInit {
  days = [];

  constructor() { super(); }

  ngOnInit() {
    this.getDays();
  }

  getMedicineName(): string {
    if (this.inData.medicationReference && this.inData.medicationReference.display) {
      return this.inData.medicationReference.display;
    }
  }

  getMedicineGroup(): string {
    if ((this.inData.category as ICodeableConcept) && (this.inData.category as ICodeableConcept).text) {
      return (this.inData.category as ICodeableConcept).text;
    }
  }

  getDoseAndRateValue(type: string): string {
    if (this.inData.dosageInstruction && this.inData.dosageInstruction.length > 0 &&
      this.inData.dosageInstruction[0].doseAndRate &&
      this.inData.dosageInstruction[0].doseAndRate.length > 0 &&
      this.inData.dosageInstruction[0].doseAndRate[0][type] &&
      this.inData.dosageInstruction[0].doseAndRate[0][type].value) {
      return this.inData.dosageInstruction[0].doseAndRate[0][type].value +
        ' ' + this.inData.dosageInstruction[0].doseAndRate[0][type].unit;
    }
  }

  getDosage(): string {
    if (this.inData.dosageInstruction && this.inData.dosageInstruction.length > 0 &&
      this.inData.dosageInstruction[0].timing && this.inData.dosageInstruction[0].timing.repeat &&
      this.inData.dosageInstruction[0].timing.repeat.periodUnit) {
      return DOSAGE_PERIODS.find(el => el.value === this.inData.dosageInstruction[0].timing.repeat.periodUnit).text;
    }
  }

  getDays(): void {
    if (this.inData.dosageInstruction && this.inData.dosageInstruction.length > 0 &&
      this.inData.dosageInstruction[0].timing &&
      this.inData.dosageInstruction[0].timing.repeat &&
      this.inData.dosageInstruction[0].timing.repeat.dayOfWeek.length > 0) {
      this.inData.dosageInstruction[0].timing.repeat.dayOfWeek.forEach((day: string) => {
        this.days.push(DAYS.find((element) => element.value === day).text);
      });
    }
  }

  getDate(): string {
    if (this.inData.dispenseRequest && this.inData.dispenseRequest.validityPeriod &&
      this.inData.dispenseRequest.validityPeriod.start) {
      return this.inData.dispenseRequest.validityPeriod.start;
    }
  }

  inDataForComment() {
    const inData = {
      authorReference: {
        display: ''
      },
      text: '',
      time: ''
    };

    if (this.inData && this.inData.note && this.inData.note[0] && this.inData.note[0].text) {
      inData.text = this.inData.note[0].text;
    }
    if (this.inData && this.inData.recorder && this.inData.recorder.display) {
      inData.authorReference.display = this.inData.recorder.display;
    }
    if (this.inData && this.inData.authoredOn) {
      inData.time = this.inData.authoredOn;
    }

    return inData;
  }
}
